import * as mutation from "./mutations-types";

export default {
  [mutation.UPDATE_SECTION](state, section) {
    state.section = section;
  }
};
